import { namespace } from 'vuex-class';
import type { AlertState as IAlertState } from './alert.types';

export const alertNamespace = 'alert';
export const Alert = namespace(alertNamespace);

export enum AlertState {
  Queue = 'queue',
}

export enum AlertMutation {
  Add = 'add',
  Remove = 'remove',
}

export enum AlertAction {
  ShowInfo = 'showInfo',
  ShowSuccess = 'showSuccess',
  ShowWarning = 'showWarning',
  ShowDanger = 'showDanger',
  Add = 'add',
  Remove = 'remove',
}

export const state: IAlertState = {
  [AlertState.Queue]: [],
};
